
<script>
import axios from 'axios';
import Url from '@/core/Url.js'
import BaseView from '@/views/Base.vue'

export default {
    name: 'base-menu-view',
    extends: BaseView,
    data () {
        return {
            menu : {},
            waiting : false,
        };
    },
    methods: {
        initMenu() {
            this.menu = this.getDefaultMenu();
            if (this.$route.params.menuId) {
                this.waiting = true;
                let params = {};
                params['id'] = this.$route.params.menuId;
                axios
                    .get(this.getMenuUrl(), {params: params})
                    .then(response => {
                        if (response.data.result) {
                            this.menu = response.data.data;
                        } else {
                            this.errorMessages.push("Se ha producido un error al consultar el menú.");
                        }
                    }).catch(() => {
                    this.errorMessages.push("Se ha producido un error al consultar el menú.");

                }).finally(() => {
                    this.waiting = false;
                });
            }
        },
        getHomePath: function () {
            return Url.getHomePath();
        },
        getMenuUrl: function () {
            return Url.getMenuUrl();
        },
        getMenuItemUrl: function () {
            return Url.getMenuItemUrl();
        },
        getDuplicateMenuItemUrl: function () {
            return Url.getDuplicateMenuItemUrl();
        },
        getMenuItemsPositionUrl: function () {
            return Url.getMenuItemsPositionUrl();
        },
        getEditMenuPath: function (menu_id) {
            return Url.getEditMenuPath(menu_id);
        },
        getListMenuItemsPath: function (menu_id) {
            return this.menu.id ? Url.getlistMenuItemsPath(menu_id) : "";
        },
        getAddMenuItemPath: function (menu_id) {
            return Url.addMenuItemPath(menu_id);
        },
        getDefaultMenu() {
            return {
                "id": 0,
                "name": "",
                "type": ""
            };
        },
    },
    created () {
        this.initMenu();
    }
}
</script>
